import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { MEDIAN_SPEED_GRADIENT_LEGEND } from '../../../constants/legends';

/**
 * ScootersSpeedLegend - Легенда медианной скорости самокатов
 * Мигрирована на новую систему легенд
 * Использует GradientLegend компонент через LegendRenderer
 */

const ScootersSpeedLegendComponent = () => (
    <LegendRenderer config={MEDIAN_SPEED_GRADIENT_LEGEND} />
);

export const ScootersSpeedLegend = withDisplayedLayersCheck(
    ScootersSpeedLegendComponent,
    t`Скорость самокатов (медиана)`
);
